// extracted by mini-css-extract-plugin
module.exports = {"disclaimer_con":"index_disclaimer_con__3x6hO"};